import initLazyLoader from './utilities/lazy-loader';
import initViewportHeightFix from './utilities/viewport-height-fix';

const utils = {
    lazyLoader: {
        init: () => {
            initLazyLoader();
        },
    },
    viewportHeightFix: {
        init: () => {
            initViewportHeightFix();
        },
    },
};

window.utils = utils;
